module.exports = __webpack_public_path__ + "1b86a49b.png";